module.exports = __webpack_public_path__ + "img/testimonial-01.886c5b36.jpg";